<template>
  <div class="camp-role-switcher">
    <button class="role-switch-trigger" type="button" @click.stop="visible = true">
      <span>{{ activeRoleName }}</span>
      <i class="role-switch-arrow" aria-hidden="true"></i>
    </button>
    <van-popup v-model="visible" class="role-switch-popup" position="bottom" round get-container="body">
      <div class="role-switch-title">切换角色视角</div>
      <button
        v-for="item in roles"
        :key="item.roleCode"
        class="role-switch-option"
        :class="{ current: item.roleCode === activeRoleCode }"
        type="button"
        @click="selectRole(item)"
      >
        <span>{{ item.roleName }}</span>
        <img
          v-if="item.roleCode === activeRoleCode"
          class="role-switch-check"
          src="@/assets/images/researchCamp/ic_x_x.svg"
          alt=""
        >
      </button>
      <button class="role-switch-cancel" type="button" @click="visible = false">取消</button>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'CampRoleSwitcher',
  props: {
    roles: {
      type: Array,
      default: () => []
    },
    activeRoleCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      visible: false
    }
  },
  computed: {
    // 当前角色名称，没有时显示切换角色
    activeRoleName () {
      const activeRole = this.roles.find(item => item.roleCode === this.activeRoleCode)
      return activeRole ? activeRole.roleName : '切换角色'
    }
  },
  methods: {
    // 选择角色后通知外层
    selectRole (role) {
      this.visible = false
      if (role.roleCode !== this.activeRoleCode) this.$emit('change', role)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../camp.less';

.camp-role-switcher {
  flex-shrink: 0;
}

.role-switch-trigger {
  display: inline-flex;
  align-items: center;
  max-width: 132px;
  height: 28px;
  padding: 0 12px;
  border: 0;
  border-radius: 14px;
  color: @camp-red;
  background: #fff2f2;
  font-size: 13px;
  line-height: 28px;
  white-space: nowrap;
}

.role-switch-trigger span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
}

.role-switch-arrow {
  width: 0;
  height: 0;
  margin-left: 6px;
  border-right: 4px solid transparent;
  border-bottom: 0;
  border-left: 4px solid transparent;
  border-top: 5px solid @camp-red;
  flex-shrink: 0;
}

.role-switch-popup {
  overflow: hidden;
  background: #f7f8fa;
}

.role-switch-title {
  padding: 16px 12px 10px;
  color: #777;
  font-size: 14px;
  text-align: center;
}

.role-switch-option,
.role-switch-cancel {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  min-height: 50px;
  margin-top: 1px;
  padding: 10px 16px;
  border: 0;
  color: #333;
  background: #fff;
  font-size: 15px;
}

.role-switch-option.current {
  color: @camp-red;
  font-weight: 500;
}

.role-switch-check {
  position: absolute;
  right: 22px;
  width: 16px;
  height: 16px;
}

.role-switch-cancel {
  min-height: 54px;
  margin-top: 8px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/views/researchCamp/components/CampRoleSwitcher.vue